import React from 'react';

import {UserLink} from 'src/components/links';

import type {LicenseInfo} from 'src/openapi/admin/models/LicenseInfo';

type Props = {
    license: LicenseInfo,
};

export const LicenseCreatorLink: React.FC<Props> = ({license}) => {
    if (!license.creatorId) {
        return <span>--</span>;
    }

    return (
        license.creatorFirstName || license.creatorLastName ? (
            <UserLink
                place="License Creator Link"
                userId={license.creatorId}
                caption={[license.creatorFirstName, license.creatorLastName].join(' ')}
            />
        ) : <UserLink userId={license.creatorId} caption="--" place="License Creator Link"/>
    );
};
